import { toast } from "react-toastify";

export const renderToast = ({ message }: { message: string }) =>
    toast(message, {
        position: "bottom-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
    });
